import { Eyebrow } from '@ghp/ui'
import { ShieldCheck } from 'lucide-react'
import type { ReactNode } from 'react'

import s from '../routes/login.module.css'

/**
 * Les deux panneaux de la connexion (frame A01), partagés par les écrans d'avant la session :
 * la connexion, « Mot de passe oublié » et le lien reçu par e-mail. Seul le volet de droite change.
 */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className={s.screen}>
      <aside className={s.brandPanel} aria-hidden>
        <div className={s.logoRow}>
          <span className={s.mark}>GHP</span>
          <span>
            <span className={s.wordmark}>GHP Pilot</span>
            <span className={s.since}>Back-office · Depuis 1996</span>
          </span>
        </div>
        <div className={s.pitchBlock}>
          <p className={s.pitch}>Pilotage des contrôles d’assainissement.</p>
          <p className={s.lede}>
            Demandes, planning des tournées, contrôles à valider et export client — centralisés pour
            les gestionnaires GHP.
          </p>
        </div>
        <p className={s.version}>{import.meta.env.VITE_APP_VERSION || 'dev'}</p>
      </aside>

      <div className={s.formPanel}>
        <div className={s.panel}>
          <Eyebrow>Espace gestionnaire</Eyebrow>
          <h1 className={s.title}>{title}</h1>

          {children}

          <p className={s.footnote}>
            <ShieldCheck size={16} aria-hidden />
            Connexion sécurisée · accès réservé aux gestionnaires GHP
          </p>
        </div>
      </div>
    </main>
  )
}
